import { Component, HostListener } from '@angular/core';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html'
})
export class HeaderComponent {
  mobileOpen = false;
  innerPage = false;

  @HostListener('window:scroll')
  onScroll(): void {
    this.innerPage = window.scrollY > 80;
  }

  closeMobile(): void {
    this.mobileOpen = false;
  }

  toggleMobile(): void {
    this.mobileOpen = !this.mobileOpen;
  }
}
